
<template>
  <v-container>
    <s-internal-proposal-data :in-dialog="false" />
  </v-container>
</template>

<script>

import SInternalProposalData from './components/SInternalProposalData'

export default {
  components: {
    SInternalProposalData
  }
}

</script>
